import * as React from "react";
const SvgIcMidChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.72 11.06 8.78 8 5.72 4.94 6.666 4l4 4-4 4-.946-.94Z" }));
export default SvgIcMidChevron;
